// Photo handling for the shop floor.
//
// A modern phone camera produces multi-megapixel JPEGs; holding one as a
// base64 data URL in React state is enough to kill the WebView on the Zebra
// tablets these run on. Downscale before the image ever enters state, and
// return bare base64 (no data: prefix) because that is what Odoo stores.

const MAX_EDGE = 1600;
const QUALITY = 0.8;

export async function downscaleToJpeg(file: File, maxEdge = MAX_EDGE): Promise<string> {
  const bitmap = await createImageBitmap(file);
  try {
    const scale = Math.min(1, maxEdge / Math.max(bitmap.width, bitmap.height));
    const width = Math.max(1, Math.round(bitmap.width * scale));
    const height = Math.max(1, Math.round(bitmap.height * scale));

    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Canvas unavailable');
    ctx.drawImage(bitmap, 0, 0, width, height);

    const dataUrl = canvas.toDataURL('image/jpeg', QUALITY);
    return dataUrl.slice(dataUrl.indexOf(',') + 1);
  } finally {
    bitmap.close();
  }
}
